import { render, staticRenderFns } from "./GeGu.vue?vue&type=template&id=836a123e"
import script from "./GeGu.vue?vue&type=script&lang=js"
export * from "./GeGu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports